import { first } from 'rxjs/operators';
import { OpsDashboardService } from '../ops-dashboard.service';
import { MessageService, ConfirmationService, LazyLoadEvent } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import {Location} from '@angular/common';
import { Router } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { ReportService } from '@app/_components/report';
import { HttpClient } from "@angular/common/http";
import { ColDef, GridOptions } from 'ag-grid-community'; // Import necessary ag-Grid types

@Component({
    selector: 'app-ops-dashboard',
    templateUrl: './ops-dashboard.component.html',
    styleUrls: ['./ops-dashboard.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class OpsDashboardComponent implements OnInit {

	//Dashboard updated dates
	lastUpdatedYieldMaxDashboard : Date;
	lastUpdatedReviewDashboard : Date;
	lastUpdatedReservationSalesDashboard : Date;
	lastUpdatedRentalUnitedDashboard : Date;
	lastUpdatedInOutDashboard : Date;
	lastUpdatedBlogsDashboard : Date;
	todayDate : Date;
	yesterdayDate : Date;
	fourteenDayDate : Date;

	todayRevRoomRateNetTTL: any;
	yesterdayRevRoomRateNetTTL: any;
	fourteenDaysRevRoomRateNetTTL: any;

	todayRevRoomRateNetAVG: any;
	yesterdayRevRoomRateNetAVG: any;
	fourteenDaysRevRoomRateNetAVG: any;

	todayNumNtsGuestTTL: any;
	yesterdayNumNtsGuestTTL: any;
	fourteenDaysNumNtsGuestTTL: any;

	todayNumNtsGuestAVG: any;
	yesterdayNumNtsGuestAVG: any;
	fourteenDaysNumNtsGuestAVG: any;

	todayRevResortTTL: any;
	yesterdayRevResortTTL: any;
	fourteenDaysRevResortTTL: any;

	todayReservationTTL: any;
	yesterdayReservationTTL: any;
	fourteenDaysReservationTTL: any;

	todayOwnerReservationTTL: any;
	yesterdayOwnerReservationTTL: any;
	fourteenDaysOwnerReservationTTL: any;

	todayNumNtsHoldTTL: any;
	yesterdayNumNtsHoldTTL: any;
	fourteenDaysNumNtsHoldTTL: any;

  //columnDefs: any[] = [];

  gridOptions: GridOptions = {
    defaultColDef: {
      width: 200,
	  sortable: true,
	  filter: true,
	  resizable: true,
    },
    rowData: [], // Initially empty
	overlayNoRowsTemplate: ''
  };
  private rowStyle: any;
  private getRowStyle: any;

	constructor(
		private primengConfig: PrimeNGConfig,
		private opsDashboardService: OpsDashboardService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private location: Location,
		private datePipe: DatePipe,
		public reportService: ReportService,
		private router: Router,
		private formBuilder: UntypedFormBuilder,
    private http: HttpClient) {

	}

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	yieldMaxRates: any;
	wikiRates: any;
	yieldMaxRateLos: any;
	wikiRateLos: any;
	properties: any;
	reservations: any;
	ruReservations: any;
	ruPricings: any;
	ruAvailabilities: any;
	ruProperties: any;
	opsDashboardDetails: any;
	lazyLoadEvent: LazyLoadEvent;
	// list
	datasource: any;
	recordTotal: number;
	multiSortMeta = [];

	//List of records with message
	logmanAPIList = [];
	showMessageInfoDialog = false;

	//Today, Yesterday and 14 days avg counts
	//Rate
	rateCreateCounts: any;
	rateModifiedCounts: any;
	rateErrorRecordCounts: any;

	//Rate LOS
	rateLosCreateCounts: any;
	rateLosModifiedCounts: any;
	rateLosErrorRecordCounts: any;

	//Properties
	propertyCreateCounts: any;
	propertyModifiedCounts: any;
	propertyErrorRecordCounts: any;

	//YieldMax Reservations
	yieldMaxReservationCreateCounts: any;
	yieldMaxReservationModifiedCounts: any;
	yieldMaxReservationErrorRecordCounts: any;

	//RU Reservation
	rUReservationCreateCounts: any;
	rUReservationModifiedCounts: any;
	rUReservationErrorRecordCounts: any;

	//RU Pricing
	ruPricingCreateCounts: any;
	ruPricingModifiedCounts: any;
	ruPricingErrorRecordCounts: any;

	//RU Availability
	ruAvailabilityCreateCounts: any;
	ruAvailabilityModifiedCounts: any;
	ruAvailabilityErrorRecordCounts: any;

	//RU Property
	ruPropertyCreateCounts: any;
	ruPropertyModifiedCounts: any;
	ruPropertyErrorRecordCounts: any;

	//Blogs
	blogCreateCounts: any;

	// Reviews
	reviewCreateCounts: any;
	wikiReview: any;
	reviewSentCounts: any;

	//InOut Dashboard
	inOutDashboardAPI: any;

	@Input() showPagination = true;

	validationMessages = {
		'startDate': [],
	};

	columns: any[] = [
		{ field: 'opsDashboardId', header: 'Id', width: 'auto' },
		{ field: 'title', header: 'Title', width: 'auto' },
		{ field: 'resultLabel', header: 'Label', width: 'auto' },
		{ field: 'resultData', header: 'Data', width: 'auto' },
		{ field: 'asOfDate', header: 'As Of Date', width: 'auto' },
		{ field: 'status', header: 'Status', width: 'auto' },
		{ field: 'referenceId', header: 'Reference', width: 'auto' },
		{ field: 'description', header: 'Description', width: 'auto' },
		{ field: 'createDate', header: 'Created On', width: 'auto' },
	];
  activeTabIndex: number = 0; // Tracks the active tab index
  rowData: any;
  columnDefs: any;
  defaultColDef: any;


  ngOnInit() {
	  if(this.activeTabIndex === 0) {
      this.initializeTab1();
    }
	}

	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.formLoading = true;
			this.lazyLoadEvent = event;

			/*console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);*/

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-property-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.opsDashboardService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.opsDashboardDetails = res.data.opsDashboardDetails;
						// console.log(JSON.stringify(res.page));
						this.formLoading = false;
					},
					(err: any) => {
						//console.log('reviews list error!: ' + JSON.stringify(err));
						this.formLoading = false;
						this.alertService.error(err);
					},
					() => { this.formLoading = false; }
				);

			if (this.datasource) {
				this.properties = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			//console.log('loadLazy(' + event + ')' + error);
			this.formLoading = false;
		}
	}

	reloadPage() {
		window.location.reload();
	}

	getDashboardDetails()
	{
		this.getYieldMaxOpsDashboardDataForProperties();
		this.getYieldMaxOpsDashboardDataForReservations();
		this.getYieldMaxOpsDashboardDataForRates();
		this.getYieldMaxOpsDashboardDataForRatesLos();
		this.getWikiOpsDashboardDataForRates();
		this.getWiKiOpsDashboardDataForRUReservation();
		this.getWiKiOpsDashboardDataForRUPricing();
		this.getWiKiOpsDashboardDataForRUAvailability();
		this.getWiKiOpsDashboardDataForRUProperty();
		this.getWikiOpsDashboardDataForRatesLos();
		this.getWikiOpsDashboardDataForReviews();
		this.getWikiOpsDashboardDataForReviewsSent();
		this.getWikiOpsDashboardDataForInOutData();
		this.getWiKiOpsDashboardDataForBlogs();
		let date = new Date();
		// Today's report
		this.runReservationRevenueReport(date, date, this.opsDashboardService.TODAY_REPORT);
		// Yesterday's report
		date.setDate(date.getDate() - 1);
		this.runReservationRevenueReport(date, date, this.opsDashboardService.YESTERDAY_REPORT);
		// last 14 days report
		let startDate = new Date();
		startDate.setDate(startDate.getDate() - 13);
		let endDate = new Date();
		this.runReservationRevenueReport(startDate, endDate, this.opsDashboardService.AVG_REPORT);
	}

	getYieldMaxOpsDashboardDataForRates() {
		try {
			this.formLoading = true;
			let requestObj = {};
			if(this.form1.get('startDate').value != null)
			{
				let startDate: Date = this.addLocalTimeToDateTime(this.form1.get('startDate').value);
				requestObj['startDate'] = startDate;
			}
			this.opsDashboardService.getYieldMaxOpsDashboardDataForRates(requestObj)
				.subscribe(
					(res: any) => {
						this.lastUpdatedYieldMaxDashboard = new Date();
						//console.log('getYieldMaxOpsDashboardDataForRates SUCCESS: ' + JSON.stringify(res));
						// this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.yieldMaxRates = res.data.rates;
						this.rateCreateCounts = res.data.rates?.createRecordCounts;
						this.rateModifiedCounts = res.data.rates?.modifiedRecordCounts;
						this.rateErrorRecordCounts = res.data.rates?.errorRecordCounts;
						//console.log(this.yieldMaxRates);
						this.formLoading = false;
					},
					(err: any) => {
						//console.log('getYieldMaxOpsDashboardDataForRates FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						this.formLoading = false;
						// this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
			this.formLoading = false;
		}
	}

	getYieldMaxOpsDashboardDataForRatesLos() {
		try {
			this.formLoading = true;
			let requestObj = {};
			if(this.form1.get('startDate').value != null)
			{
				let startDate: Date = this.addLocalTimeToDateTime(this.form1.get('startDate').value);
				requestObj['startDate'] = startDate;
			}
			this.opsDashboardService.getYieldMaxOpsDashboardDataForRatesLos(requestObj)
				.subscribe(
					(res: any) => {
						this.lastUpdatedYieldMaxDashboard = new Date();
						//console.log('getYieldMaxOpsDashboardDataForRatesLos SUCCESS: ' + JSON.stringify(res));
						// this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.yieldMaxRateLos = res.data.rateLos;
						this.rateLosCreateCounts = res.data.rateLos?.createRecordCounts;
						this.rateLosModifiedCounts = res.data.rateLos?.modifiedRecordCounts;
						this.rateLosErrorRecordCounts = res.data.rateLos?.errorRecordCounts;
						// console.log(this.yieldMaxRateLos);
						this.formLoading = false;
					},
					(err: any) => {
						// console.log('getYieldMaxOpsDashboardDataForRatesLos FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						this.formLoading = false;
						// this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
			this.formLoading = false;
		}
	}

	onReservationSaleHdrClick()
	{
		const url = this.router.serializeUrl(
			this.router.createUrlTree(['/res-sales-dashboard'])
		  );

		  window.open(url, '_blank');
	}

	onReviewHdrClick()
	{
		const url = this.router.serializeUrl(
			this.router.createUrlTree(['/review-list'])
		  );

		  window.open(url, '_blank');
	}

	onYieldMaxErrorClick(severity: any, referenceId: any, forPastNumOfHours: any, day: any)
	{
		let filterDay: Date;
		let baseUrl = '/logmans-yieldmax/' + referenceId + '/' + severity;

		if(day != null && day != '')
		{
			let today = new Date();
			if(day == 'today')
			{
				let todayDate = this.datePipe.transform(today, 'yyyy-MM-dd');
				baseUrl = baseUrl + '/' + todayDate;
			}
			else if(day == 'yesterday')
			{
				today.setDate(today.getDate() - 1);
				let yesterdayDate = this.datePipe.transform(today, 'yyyy-MM-dd');
				baseUrl = baseUrl + '/' + yesterdayDate;
			}
		}
		const url = this.router.serializeUrl(
			this.router.createUrlTree([baseUrl])
		  );

		  window.open(url, '_blank');

		// try {
		// 	this.formLoading = true;
		// 	let requestObj = {};
		// 	if(this.form1.get('startDate').value != null)
		// 	{
		// 		let startDate: Date = this.addLocalTimeToDateTime(this.form1.get('startDate').value);
		// 		requestObj['startDate'] = startDate;
		// 	}
		// 	requestObj['forPastNumOfHours'] = forPastNumOfHours;
		// 	requestObj['severity'] = severity;
		// 	requestObj['referenceId'] = referenceId;
		// 	this.opsDashboardService.getYieldMaxMessageDetailsByReferenceId(requestObj)
		// 		.subscribe(
		// 			(res: any) => {
		// 				console.log('getYieldMaxMessageDetailsByReferenceId SUCCESS: ' + JSON.stringify(res));
		// 				this.logmanAPIList = res.data.logmanAPIList;
		// 				this.showMessageInfoDialog = true;
		// 				// this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
		// 				this.formLoading = false;
		// 			},
		// 			(err: any) => {
		// 				console.log('getYieldMaxMessageDetailsByReferenceId FAIL: ' + JSON.stringify(err));
		// 				this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
		// 				this.formLoading = false;
		// 				// this.alertService.error(err);
		// 			},
		// 			() => { this.formLoading = false; });
		// } catch (error) {
		// 	this.alertService.error(error);
		// 	this.formLoading = false;
		// }
	}

	onYieldMaxSuccessClick(module: any, day: any, filterBy)
	{
		let baseUrl = '';
		let filterDate = null;
		let queryParams = {};

		if(module != null && module != '')
		{
			if(module == 'RATES')
			{
				baseUrl = '/rates';
			}
			if(module == 'RATES_LOS')
			{
				baseUrl = '/ratesLos';
			}
			if(module == 'PROPERTY')
			{
				baseUrl = '/ym-properties';
			}
			if(module == 'RESERVATION')
			{
				baseUrl = '/ym-reservations';
			}
		}

		if(day != null && day != '')
		{
			let today = new Date();
			if(day == 'today')
			{
				filterDate = this.datePipe.transform(today, 'yyyy-MM-dd');
			}
			else if(day == 'yesterday')
			{
				today.setDate(today.getDate() - 1);
				filterDate = this.datePipe.transform(today, 'yyyy-MM-dd');
			}
		}
		if(filterBy != null && filterBy != '')
		{
			if(filterBy == 'CREATE_DATE')
			{
				if(filterDate != null)
				{
					queryParams = {
						createDate: filterDate
					};
				}
			}
			if(filterBy == 'UPDATE_DATE')
			{
				if(filterDate != null)
				{
					queryParams = {
						updateDate: filterDate
					};
				}
			}
		}

		const url = this.router.serializeUrl(
			this.router.createUrlTree([baseUrl], {
				queryParams: queryParams
			})
		  );
		  window.open(url, '_blank');
	}

	onWikiErrorClick(severity: any, referenceId: any, forPastNumOfHours: any)
	{
		try {
			this.formLoading = true;
			let requestObj = {};
			if(this.form1.get('startDate').value != null)
			{
				let startDate: Date = this.addLocalTimeToDateTime(this.form1.get('startDate').value);
				requestObj['startDate'] = startDate;
			}
			requestObj['forPastNumOfHours'] = forPastNumOfHours;
			requestObj['severity'] = severity;
			requestObj['referenceId'] = referenceId;
			this.opsDashboardService.getWikiMessageDetailsByReferenceId(requestObj)
				.subscribe(
					(res: any) => {
						// console.log('getWikiMessageDetailsByReferenceId SUCCESS: ' + JSON.stringify(res));
						this.logmanAPIList = res.data.logmanAPIList;
						this.showMessageInfoDialog = true;
						// this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.formLoading = false;
					},
					(err: any) => {
						// console.log('getWikiMessageDetailsByReferenceId FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						this.formLoading = false;
						// this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
			this.formLoading = false;
		}
	}

	syncDashboardDetails() {
		try {
			this.formLoading = true;
			let requestObj = {};
			if(this.form1.get('startDate').value != null)
			{
				let startDate: Date = this.addLocalTimeToDateTime(this.form1.get('startDate').value);
				requestObj['startDate'] = startDate;
			}
			this.opsDashboardService.syncDashboardDetails(requestObj)
				.subscribe(
					(res: any) => {
						// console.log('syncDashboardDetails SUCCESS: ' + JSON.stringify(res));
						// this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.formLoading = false;
					},
					(err: any) => {
						// console.log('syncDashboardDetails FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						this.formLoading = false;
						// this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
			this.formLoading = false;
		}
	}

	getYieldMaxOpsDashboardDataForProperties() {
		try {
			this.formLoading = true;
			let requestObj = {};
			if(this.form1.get('startDate').value != null)
			{
				let startDate: Date = this.addLocalTimeToDateTime(this.form1.get('startDate').value);
				requestObj['startDate'] = startDate;
			}
			this.opsDashboardService.getYieldMaxOpsDashboardDataForProperties(requestObj)
				.subscribe(
					(res: any) => {
						this.lastUpdatedYieldMaxDashboard = new Date();
						// console.log('getYieldMaxOpsDashboardDataForProperties SUCCESS: ' + JSON.stringify(res));
						// this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.properties = res.data.properties;
						this.propertyCreateCounts = res.data.properties?.createRecordCounts;
						this.propertyModifiedCounts = res.data.properties?.modifiedRecordCounts;
						this.propertyErrorRecordCounts = res.data.properties?.errorRecordCounts;
						// console.log(this.properties);
						this.formLoading = false;
					},
					(err: any) => {
						// console.log('getYieldMaxOpsDashboardDataForProperties FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						this.formLoading = false;
						// this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
			this.formLoading = false;
		}
	}

	getYieldMaxOpsDashboardDataForReservations() {
		try {
			this.formLoading = true;
			let requestObj = {};
			if(this.form1.get('startDate').value != null)
			{
				let startDate: Date = this.addLocalTimeToDateTime(this.form1.get('startDate').value);
				requestObj['startDate'] = startDate;
			}
			this.opsDashboardService.getYieldMaxOpsDashboardDataForReservations(requestObj)
				.subscribe(
					(res: any) => {
						this.lastUpdatedYieldMaxDashboard = new Date();
						// console.log('getYieldMaxOpsDashboardDataForReservations SUCCESS: ' + JSON.stringify(res));
						// this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.reservations = res.data.reservations;
						this.yieldMaxReservationCreateCounts = res.data.reservations?.createRecordCounts;
						this.yieldMaxReservationModifiedCounts = res.data.reservations?.modifiedRecordCounts;
						this.yieldMaxReservationErrorRecordCounts = res.data.reservations?.errorRecordCounts;
						// console.log(this.reservations);
						this.formLoading = false;
					},
					(err: any) => {
						// console.log('getYieldMaxOpsDashboardDataForReservations FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						this.formLoading = false;
						// this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
			this.formLoading = false;
		}
	}

	getWiKiOpsDashboardDataForRUReservation() {
		try {
			this.formLoading = true;
			let requestObj = {};
			if(this.form1.get('startDate').value != null)
			{
				let startDate: Date = this.addLocalTimeToDateTime(this.form1.get('startDate').value);
				requestObj['startDate'] = startDate;
			}
			this.opsDashboardService.getWiKiOpsDashboardDataForRUReservation(requestObj)
				.subscribe(
					(res: any) => {
						this.lastUpdatedRentalUnitedDashboard = new Date();
						// console.log('getWiKiOpsDashboardDataForRUReservation SUCCESS: ' + JSON.stringify(res));
						// this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.ruReservations = res.data.reservations;
						this.rUReservationCreateCounts = res.data.reservations?.createRecordCounts;
						this.rUReservationModifiedCounts = res.data.reservations?.modifiedRecordCounts;
						this.rUReservationErrorRecordCounts = res.data.reservations?.errorRecordCounts;
						// console.log(this.ruReservations);
						this.formLoading = false;
					},
					(err: any) => {
						// console.log('getWiKiOpsDashboardDataForRUReservation FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						this.formLoading = false;
						// this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
			this.formLoading = false;
		}
	}

	getWiKiOpsDashboardDataForBlogs() {
		try {
			this.formLoading = true;
			let requestObj = {};
			if(this.form1.get('startDate').value != null)
			{
				let startDate: Date = this.addLocalTimeToDateTime(this.form1.get('startDate').value);
				requestObj['startDate'] = startDate;
			}
			this.opsDashboardService.getWiKiOpsDashboardDataForBlogs(requestObj)
				.subscribe(
					(res: any) => {
						this.lastUpdatedBlogsDashboard = new Date();
						// console.log('getWiKiOpsDashboardDataForBlogs SUCCESS: ' + JSON.stringify(res));
						this.blogCreateCounts = res.data.blogs?.createRecordCounts;
						// console.log(this.ruReservations);
						this.formLoading = false;
					},
					(err: any) => {
						// console.log('getWiKiOpsDashboardDataForBlogs FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						this.formLoading = false;
						// this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
			this.formLoading = false;
		}
	}

	getWiKiOpsDashboardDataForRUPricing() {
		try {
			this.formLoading = true;
			let requestObj = {};
			if(this.form1.get('startDate').value != null)
			{
				let startDate: Date = this.addLocalTimeToDateTime(this.form1.get('startDate').value);
				requestObj['startDate'] = startDate;
			}
			this.opsDashboardService.getWiKiOpsDashboardDataForRUPricing(requestObj)
				.subscribe(
					(res: any) => {
						this.lastUpdatedRentalUnitedDashboard = new Date();
						// console.log('getWiKiOpsDashboardDataForRUPricing SUCCESS: ' + JSON.stringify(res));
						// this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.ruPricings = res.data.pricing;
						this.ruPricingCreateCounts = res.data.pricing?.createRecordCounts;
						// this.rUReservationModifiedCounts = res.data.pricing?.modifiedRecordCounts;
						this.ruPricingErrorRecordCounts = res.data.pricing?.errorRecordCounts;
						// console.log(this.ruPricings);
						this.formLoading = false;
					},
					(err: any) => {
						// console.log('getWiKiOpsDashboardDataForRUPricing FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						this.formLoading = false;
						// this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
			this.formLoading = false;
		}
	}

	getWiKiOpsDashboardDataForRUAvailability() {
		try {
			this.formLoading = true;
			let requestObj = {};
			if(this.form1.get('startDate').value != null)
			{
				let startDate: Date = this.addLocalTimeToDateTime(this.form1.get('startDate').value);
				requestObj['startDate'] = startDate;
			}
			this.opsDashboardService.getWiKiOpsDashboardDataForRUAvailability(requestObj)
				.subscribe(
					(res: any) => {
						this.lastUpdatedRentalUnitedDashboard = new Date();
						// console.log('getWiKiOpsDashboardDataForRUAvailability SUCCESS: ' + JSON.stringify(res));
						// this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.ruAvailabilities = res.data.availabilities;
						this.ruAvailabilityCreateCounts = res.data.availabilities?.createRecordCounts;
						// this.ruAvailabilityModifiedCounts = res.data.availabilities?.modifiedRecordCounts;
						this.ruAvailabilityErrorRecordCounts = res.data.availabilities?.errorRecordCounts;
						// console.log(this.ruAvailabilities);
						this.formLoading = false;
					},
					(err: any) => {
						// console.log('getWiKiOpsDashboardDataForRUAvailability FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						this.formLoading = false;
						// this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
			this.formLoading = false;
		}
	}

	getWiKiOpsDashboardDataForRUProperty() {
		try {
			this.formLoading = true;
			let requestObj = {};
			if(this.form1.get('startDate').value != null)
			{
				let startDate: Date = this.addLocalTimeToDateTime(this.form1.get('startDate').value);
				requestObj['startDate'] = startDate;
			}
			this.opsDashboardService.getWiKiOpsDashboardDataForRUProperty(requestObj)
				.subscribe(
					(res: any) => {
						this.lastUpdatedRentalUnitedDashboard = new Date();
						// console.log('getWiKiOpsDashboardDataForRUProperty SUCCESS: ' + JSON.stringify(res));
						// this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.ruProperties = res.data.properties;
						this.ruPropertyCreateCounts = res.data.properties?.createRecordCounts;
						// this.ruPropertyModifiedCounts = res.data.properties?.modifiedRecordCounts;
						this.ruPropertyErrorRecordCounts = res.data.properties?.errorRecordCounts;
						// console.log(this.ruProperties);
						this.formLoading = false;
					},
					(err: any) => {
						// console.log('getWiKiOpsDashboardDataForRUProperty FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						this.formLoading = false;
						// this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
			this.formLoading = false;
		}
	}

	getWikiOpsDashboardDataForRates() {
		try {
			this.formLoading = true;
			let requestObj = {};
			if(this.form1.get('startDate').value != null)
			{
				let startDate: Date = this.addLocalTimeToDateTime(this.form1.get('startDate').value);
				requestObj['startDate'] = startDate;
			}
			this.opsDashboardService.getWikiOpsDashboardDataForRates(requestObj)
				.subscribe(
					(res: any) => {
						// console.log('getWikiOpsDashboardDataForRates SUCCESS: ' + JSON.stringify(res));
						// this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.wikiRates = res.data.rates;
						// console.log(this.wikiRates);
						this.formLoading = false;
					},
					(err: any) => {
						// console.log('getWikiOpsDashboardDataForRates FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						this.formLoading = false;
						// this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
			this.formLoading = false;
		}
	}

	getWikiOpsDashboardDataForRatesLos() {
		try {
			this.formLoading = true;
			let requestObj = {};
			if(this.form1.get('startDate').value != null)
			{
				let startDate: Date = this.addLocalTimeToDateTime(this.form1.get('startDate').value);
				requestObj['startDate'] = startDate;
			}
			this.opsDashboardService.getWikiOpsDashboardDataForRatesLos(requestObj)
				.subscribe(
					(res: any) => {
						// console.log('getWikiOpsDashboardDataForRatesLos SUCCESS: ' + JSON.stringify(res));
						// this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.wikiRateLos = res.data.rateDetailLos;
						// console.log(this.wikiRateLos);
						this.formLoading = false;
					},
					(err: any) => {
						// console.log('getWikiOpsDashboardDataForRatesLos FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						this.formLoading = false;
						// this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
			this.formLoading = false;
		}
	}

	runReservationRevenueReport(fromDate, toDate, reportName) {
		try {
			this.formLoading = true;
			let searchForm:any = {};
			searchForm.reservationStatusList = this.reportService.revanueReservations; // Fetch only active reservations
			searchForm.saleDateStart = this.addLocalTimeToDateTime(fromDate);
			searchForm.saleDateEnd = this.addLocalTimeToDateTime(toDate);
			this.reportService.reservationRevenueReport(searchForm)
				.subscribe(
					res => {
						this.lastUpdatedReservationSalesDashboard = new Date();
//						// console.log('runReservationRevenueReport SUCCESS: ' + JSON.stringify(res));

						let resRevMaster:Array<any> = res.data.resRevenues.resRevMaster;
						let resRevTotal:Array<any> = res.data.resRevenues.resRevTotal;
						let numResTTL = 0.0;
						let numNtsGuestTTL = 0.0;
						let numNtsGuestAVG = 0.0;
						let revRoomRateNetTTL = 0.0;
						let revRoomRateNetAVG = 0.0;
						let revResortTTL = 0.0;
						let ownerReservation = 0;
						let numNtsHoldTTL = 0;

						if(resRevTotal && resRevTotal.length > 0) {
							revRoomRateNetTTL = resRevTotal[0].revRoomRateNetTTL;
							revRoomRateNetAVG = resRevTotal[0].revRoomRateNetAVG;
							numResTTL = resRevTotal[0].numResTTL;
							numNtsGuestTTL = resRevTotal[0].numNtsGuestTTL;
							numNtsHoldTTL = resRevTotal[0].numNtsHoldTTL;
							if(numResTTL && numResTTL != 0)
							{
								numNtsGuestAVG = numNtsGuestTTL / numResTTL;
							}
						}

						if(resRevMaster != null)
						{
							resRevMaster.forEach(resRevMstr => {
								// revRoomRateNetTTL = revRoomRateNetTTL + resRevMstr.revRoomRateNetTTL;
								revResortTTL = revResortTTL + resRevMstr.revResortTTL;
								if(resRevMstr.resStatus != null && (resRevMstr.resStatus == 'OG' || resRevMstr.resStatus == 'OO'))
								{
									ownerReservation = ownerReservation + 1;
								}
							});
							if(reportName == this.opsDashboardService.TODAY_REPORT)
							{
								this.todayRevRoomRateNetTTL = revRoomRateNetTTL;
								this.todayRevRoomRateNetAVG = revRoomRateNetAVG;
								this.todayNumNtsGuestTTL = numNtsGuestTTL;
								this.todayNumNtsGuestAVG = numNtsGuestAVG;
								this.todayRevResortTTL = revResortTTL;
								this.todayNumNtsHoldTTL = numNtsHoldTTL;
								// this.todayReservationTTL = resRevMaster.length;
								this.todayReservationTTL = numResTTL;
								this.todayOwnerReservationTTL = ownerReservation;
							}
							else if(reportName == this.opsDashboardService.YESTERDAY_REPORT)
							{
								this.yesterdayRevRoomRateNetTTL = revRoomRateNetTTL;
								this.yesterdayRevRoomRateNetAVG = revRoomRateNetAVG;
								this.yesterdayNumNtsGuestTTL = numNtsGuestTTL;
								this.yesterdayNumNtsGuestAVG = numNtsGuestAVG;
								this.yesterdayRevResortTTL = revResortTTL;
								this.yesterdayNumNtsHoldTTL = numNtsHoldTTL;
								// this.yesterdayReservationTTL = resRevMaster.length;
								this.yesterdayReservationTTL = numResTTL;
								this.yesterdayOwnerReservationTTL = ownerReservation;
							}
							else if(reportName == this.opsDashboardService.AVG_REPORT)
							{
								this.fourteenDaysRevRoomRateNetTTL = revRoomRateNetTTL;
								this.fourteenDaysRevRoomRateNetAVG = revRoomRateNetAVG;
								this.fourteenDaysNumNtsGuestTTL = numNtsGuestTTL;
								this.fourteenDaysNumNtsGuestAVG = numNtsGuestAVG;
								this.fourteenDaysRevResortTTL = revResortTTL;
								this.fourteenDaysNumNtsHoldTTL = numNtsHoldTTL;
								// this.fourteenDaysReservationTTL = resRevMaster.length;
								this.fourteenDaysReservationTTL = numResTTL;
								this.fourteenDaysOwnerReservationTTL = ownerReservation;
							}
						}
					},
					err => {
						// console.log('runReservationRevenueReport FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: runReservationRevenueReport' });
		}
	}

	getWikiOpsDashboardDataForReviews() {
		try {
			this.opsDashboardService.getWikiOpsDashboardDataForReviews()
				.subscribe(
					(res: any) => {
						this.lastUpdatedReviewDashboard = new Date();
						// console.log('getWikiOpsDashboardDataForReviews SUCCESS: ' + JSON.stringify(res));
						this.wikiReview = res.data.reviews;
						this.reviewCreateCounts = res.data.reviews?.createRecordCounts;
						this.formLoading = false;
					},
					(err: any) => {
						// console.log('getWikiOpsDashboardDataForReviews FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						this.formLoading = false;
						// this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
			this.formLoading = false;
		}
	}

	getWikiOpsDashboardDataForReviewsSent() {
		try {
			this.opsDashboardService.getWikiOpsDashboardDataForReviewsSent()
				.subscribe(
					(res: any) => {
						this.lastUpdatedReviewDashboard = new Date();
						// console.log('getWikiOpsDashboardDataForReviewsSent SUCCESS: ' + JSON.stringify(res));
						this.reviewSentCounts = res.data.reviews?.createRecordCounts;
						this.formLoading = false;
					},
					(err: any) => {
						// console.log('getWikiOpsDashboardDataForReviewsSent FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						this.formLoading = false;
						// this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
			this.formLoading = false;
		}
	}

	getWikiOpsDashboardDataForInOutData() {
		try {
			this.opsDashboardService.getWikiOpsDashboardDataForInOutData()
				.subscribe(
					(res: any) => {
						this.lastUpdatedInOutDashboard = new Date();
//						// console.log('getWikiOpsDashboardDataForInOutData SUCCESS: ' + JSON.stringify(res));
						this.inOutDashboardAPI = res.data.inOutDetails?.inOutDashboardAPI;
						this.formLoading = false;
					},
					(err: any) => {
//						// console.log('getWikiOpsDashboardDataForInOutData FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						this.formLoading = false;
						// this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
			this.formLoading = false;
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			startDate: []
		});
	}

	/**
	 * Add time plus local time GMT hours as http request change time to UTC time
	 * @param datetime
	 * @returns
	 */
	addLocalTimeToDateTime(datetime) {
		return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
	}

  onTabChange(event: any) {
    this.activeTabIndex = event !== -1 ? Number(event) : this.activeTabIndex; // Index of the clicked tab
    if(this.activeTabIndex === 0) {
      this.formLoading = true;
      this.initializeTab1();
      this.formLoading = false;
    } else if(this.activeTabIndex === 1) {
      this.initializeTab2();
    }
   // this.fetchTabData(activeTabIndex);
    // console.log(activeTabIndex);
  }

  private initializeTab1() {

    this.primengConfig.ripple = true;
    this.multiSortMeta = [];
    this.multiSortMeta.push({field: 'createDate', order: 0});
    this.formBuild();
    this.getDashboardDetails();
    this.todayDate = new Date();
    this.yesterdayDate = new Date();
    this.fourteenDayDate = new Date();
    this.yesterdayDate.setDate(this.yesterdayDate.getDate() - 1);
    this.fourteenDayDate.setDate(this.fourteenDayDate.getDate() - 13);
    this.todayDate = new Date();

  }

  onWrapperClick(event: any) {
    // console.log("----------------->" + event.target.id);
    this.onTabChange(this.extractNumber(event.target.id));
  }

  extractNumber(text: string) {
    const match = text.match(/p-tabpanel-(\d+)-label/);
    return match ? parseInt(match[1], 10) : -1; // Return -1 if no match found
  }

  private initializeTab2() {

  }

  convertToCurrency(amount:any):any{
		return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD',
			minimumFractionDigits: 0,
			maximumFractionDigits: 0
		}).format(
			amount
		)
   }
}
